import { Center, Container, Image, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function NotFound() {
  const location = useLocation();

  const [session, setSession] = useState(false);

  useEffect(() => {
    if (location.state && location.state.session) {
      setSession(true);
    }
  }, []);
  console.log(location);
  return (
    <Container>
      <Center h="100vh" flexDirection={"column"}>
        <Image
          src="/assets/images/icn_marks_exclamation.svg"
          boxSize={"56px"}
        />
        <Text
          mt={"16px"}
          fontSize="22px"
          fontWeight={"semibold"}
          textColor="black"
        >
          {location.state && location.state.session
            ? "네트워크 연결이 종료되었어요"
            : "정상적인 경로가 아닙니다"}
        </Text>
        {localStorage.getItem("channel") !== "smcare" &&
          localStorage.getItem("channel") !== "cosmocare" && (
            <Text mt={"12px"} fontSize="14px" textColor="#757575">
              {location.state && location.state.session
                ? "입주자 앱에서 다시 방문해 주세요"
                : "입주자 앱을 통해 이용해 주세요"}
            </Text>
          )}
      </Center>
    </Container>
  );
}
export default NotFound;
